import React from 'react'

function InviteAcceptancePage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow p-6">
        <div className="mb-4">
          <h1 className="text-2xl font-semibold">Accept Invitation</h1>
          <p className="text-sm text-gray-500">You have been invited to establish a partnership.</p>
        </div>
        <div className="space-y-3 text-sm">
          <div className="border rounded-lg p-3">
            <div className="font-medium">Invitation details</div>
            <div className="text-gray-600">Fleet: Fleet Alpha</div>
            <div className="text-gray-600">Hospital: NewHope Hospital</div>
          </div>
          <div className="text-xs text-gray-500">Proceeding will link your organization after verification. You may need to login/sign up.</div>
          <div className="flex gap-2">
            <button className="px-4 py-2 rounded-lg bg-green-600 text-white">Accept</button>
            <button className="px-4 py-2 rounded-lg bg-gray-100">Decline</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InviteAcceptancePage


